<template>
  <div class="about">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col class="text-center">
          <h1>This is an about page</h1>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
